export const iconFontAwesomeDesignPenRuler = (
	<i className="fa-solid fa-pen-ruler"></i>
);
